export function sliceAuthorName(authorName: string): string {
    const regexp = /\|.AEQUO/gi;
    return authorName.replace(regexp, '');
}
